module.exports = __webpack_public_path__ + "e74bccaa1d7905a89e2d54835f3f7dc5.svg";